import { useMutation } from 'react-query';

import { createUser, userCreateParams } from '../utils/backend-api/users';

export default function useCreateUser() {
  const { mutateAsync, data, isLoading, isError } = useMutation((params: userCreateParams) =>
    createUser(params)
  );
  return { mutateAsync, data, isLoading, isError };
}
